import { DeepNullable } from '@shared/utils';

export type BrowserDataStateInterface = DeepNullable<BrowserDataInterface>;

export enum BrowserDataFieldsEnum {
  cookieAcceptValues = 'cookieAcceptValues',
  authenticated = 'authenticated',
}

export interface BrowserDataInterface {
  [BrowserDataFieldsEnum.cookieAcceptValues]: CookieAcceptValue;
  [BrowserDataFieldsEnum.authenticated]: boolean;
}

export interface CookieAcceptValue {
  analyticsCookies?: boolean;
  essentialCookies?: boolean;
  marketingCookies?: boolean;
  allCookies?: boolean;
}
